/** @jsx jsx */
import * as React from "react";
import * as _ from "lodash";
import ILabTestMaster from "../models/ILabTestMaster";
import ILabTest from "../models/ILabTest";
import ModelFactory from "../models/ModelFactory";
import AppUtils from "../utils/AppUtils";
import CollapsibleCardView from "./CollapsibleCardView";
import AssetProvider from "../utils/AssetProvider";
import { AlbusUrlConfigs } from "../api/AlbusUrlConfigs";
import PatientLabTestsEditor from "./patient/edit/PatientDiagnosticLabTestsEditor";
import { ModalComponent } from "./ModalComponent";
import { labTestStyles } from "../styles/ongoing/labtests";
import { css, jsx } from "@emotion/core"
import LabTestRowSideBar from "./LabTestRowSidebar";
import LabTestRow from "./LabTestRow";


/**
 * Created by aditya on 6/05/18.
 */


interface AllLabTestsContainerProps {
    labTests: ILabTestMaster[];
    userId: string;
    diagnosticLabTests?: any;
    newFormat: { [key: string]: any };
    getRightSideUI(newFormat: any, date: string): React.ReactNode;
}


interface PatientLabTestsContainerState {
    openModal: boolean,
    reportLink: string,
    textToCopy: string,
    textCopied: boolean,
    expandedTabIndex: number,
    testsToShow: ILabTest[];
    workingDate: string;
    reportsToShow: any[];
    labTest: ILabTestMaster;
    showDetails: boolean,
    detailToShow: any,
    newFormatDateSelected: string;
    rightSideUi: React.ReactNode;
}

class AllLabTestsContainer extends React.Component<AllLabTestsContainerProps, PatientLabTestsContainerState> {

    constructor(props: AllLabTestsContainerProps) {
        super(props);
        this.state = {
            openModal: false,
            reportLink: null,
            textToCopy: null,
            textCopied: false,
            expandedTabIndex: -1,
            testsToShow: [],
            workingDate: "",
            reportsToShow: [],
            labTest: null,
            showDetails: false,
            detailToShow: null,
            newFormatDateSelected: null,
            rightSideUi: undefined
        }
    }

    generateFormattedLabTestRow(childCheckUpReportInfo: ILabTest[]) {
        let formattedLabTests: ILabTest[] = [];
        let labTests = !_.isEmpty(childCheckUpReportInfo) ? childCheckUpReportInfo : [];
        formattedLabTests = formattedLabTests.concat(labTests.filter(item => _.isNull(item.reportDetails)));
        if (labTests.filter(item => !_.isNull(item.reportDetails)).length !== 0) {
            let firstLevelReports = labTests.filter(item => !_.isNull(item.reportDetails));
            let firstLevelReportsId = firstLevelReports.map(item => item.reportDetails.packageProfileName);
            let uniqueItems = Array.from(new Set(firstLevelReportsId));
            _.map(uniqueItems, (uniqueId) => {
                let labTest = ModelFactory.createNewLabTestObject();
                labTest.childCheckUpReportInfo = labTests.filter(item => !_.isNull(item.reportDetails) && item.reportDetails.packageProfileName === uniqueId);
                formattedLabTests.push(labTest);
            })
        }
        return formattedLabTests;
    }

    handleReportClick = (labTest: any, orderAsset: any) => {
        const url = AlbusUrlConfigs.getReportsPdfUrl(this.props.userId, labTest.bookingId, labTest.orderId, orderAsset.reportId);
        if (orderAsset.passCode) {
            this.setState({
                openModal: true,
                reportLink: url,
                textToCopy: orderAsset.passCode
            })
        } else {
            this.openReport(url)
        }
    }

    openReport = (url: string) => {
        window.open(url, "_blank");
    }

    resetState = () => {
        this.setState({
            openModal: false,
            reportLink: null,
            textToCopy: null,
            textCopied: false
        })
    }

    openPasswordProtectedReport = () => {
        this.openReport(this.state.reportLink)
    }

    handleCopyText = () => {
        AppUtils.copyTextToClipboard(this.state.textToCopy).then((res: any) => {
            console.log(res)
            this.setState({
                textCopied: true
            })
        }).catch((e: any) => {
            console.log(e)
        })
    }

    expandDate = (index: number, testsToShow: ILabTest[], workingDate: string) => {
        this.setState({ expandedTabIndex: index, testsToShow, workingDate, reportsToShow: [], newFormatDateSelected: null, rightSideUi: null });
    }

    expandDateNewFormat = (date: string) => {
        const rightSideUi: React.ReactNode = this.props.getRightSideUI(this.props.newFormat, date);
        this.setState({ expandedTabIndex: -1, testsToShow: [], workingDate: date, reportsToShow: [], rightSideUi });
    }

    showReports = (e: React.MouseEvent<HTMLDivElement, MouseEvent>, index: number, reportsToShow: any[], workingDate: string, labTest: ILabTestMaster, isMobile: boolean) => {
        e.stopPropagation();
        const state: any = { expandedTabIndex: index, testsToShow: [], workingDate, reportsToShow, labTest, detailToShow: null }
        if (isMobile) state["showDetails"] = true
        this.setState(state);
    }

    handleLabTestClick = (labTest: ILabTest, isMobile: boolean) => {
        console.log({ labTest })
        if (isMobile) {
            this.setState({
                showDetails: true,
                detailToShow: labTest
            })
        }
    }

    handleBackClick = () => {
        this.setState({
            showDetails: false,
            detailToShow: null
        })
    }

    render() {
        const copiedClass = this.state.textCopied ? "active" : "hidden";
        const isMobile = AppUtils.getIsMobile();
        const { expandedTabIndex, testsToShow, workingDate, reportsToShow, labTest, newFormatDateSelected, rightSideUi } = this.state;
        const { newFormat } = this.props;
        const labTestReportsCont = (<div id="all-lab-test-container" css={labTestStyles.labReportsContainer}>
            {_.map(reportsToShow, (orderAsset, index) => {
                let imageUrl = orderAsset.reportType === "PDF" ? "/images/icons/pdf-icon.svg" : "/images/icons/jpg-icon.svg";
                let buttonText = !_.isEmpty(orderAsset.reportName)
                    ? orderAsset.reportName
                    : orderAsset.reportType === "PDF"
                        ? "PDF Report"
                        : "Image Report";
                return <div key={`reports-pdf-link-${index}`} css={labTestStyles.iconsWrapper}>
                    <div onClick={() => this.handleReportClick(labTest, orderAsset)}>
                        <img src={imageUrl} css={labTestStyles.pdfIcon} />
                        <div css={labTestStyles.iconText}>{buttonText}</div>
                    </div>
                </div>
            })}
        </div>)
        return (
            <div css={labTestStyles.labTestContainer}>
                {!this.state.showDetails && <div className="patient-labtests-container">

                    {
                        _.isEmpty(this.props.labTests) && _.isEmpty(this.props.diagnosticLabTests) &&
                        <div className={"no-labtests-info"}>
                            No Lab Tests Details Available
                    </div>
                    }

                    {
                        !_.isEmpty(this.props.labTests) &&
                        <div css={labTestStyles.leftNavConatiner}>
                            <div>
                                <div css={labTestStyles.labTestNavHeaderText}>Lab Tests</div>
                                <input css={labTestStyles.searchBox} />
                                <span className="glyphicon glyphicon-search" css={labTestStyles.searchIcon}></span>
                            </div>
                            <div>
                                {
                                    _.map(this.props.labTests, (labTest: ILabTestMaster, rootIndex: number) => {
                                        if (!_.isEmpty(labTest.atHomeDiagnosticOrder) || !_.isEmpty(labTest.inCentreDiagnosticOrder)) {
                                            let reportsPdf = !_.isEmpty(labTest.finalDiagnosticReport) &&
                                                !_.isEmpty(labTest.finalDiagnosticReport.userDiagnosticsReport) &&
                                                !_.isEmpty(labTest.finalDiagnosticReport.userDiagnosticsReport.diagnosticReports) ? labTest.finalDiagnosticReport.userDiagnosticsReport.diagnosticReports : [];
                                            let labTestItem = !_.isEmpty(labTest.finalDiagnosticReport) && !_.isEmpty(labTest.finalDiagnosticReport.diagnosticCheckUpReportInfo) ? labTest.finalDiagnosticReport.diagnosticCheckUpReportInfo : null;
                                            let labTestRow = !_.isEmpty(labTestItem) && !_.isEmpty(labTestItem.childCheckUpReportInfo) ? this.generateFormattedLabTestRow(labTestItem.childCheckUpReportInfo) : [];
                                            let workingDate = !_.isEmpty(labTest.inCentreDiagnosticOrder) ? labTest.inCentreDiagnosticOrder.slot.workingDate : labTest.atHomeDiagnosticOrder.startTime;
                                            const isExpanded: boolean = rootIndex === expandedTabIndex;
                                            const date: string = AppUtils.getRelativeDay(workingDate, "", true);
                                            return <div className={"labTest-container"} key={`labTest-root-${rootIndex}`} onClick={() => this.expandDate(rootIndex, labTestRow, date)}>
                                                <div css={isExpanded ? { ...labTestStyles.expandedLabTest, padding: "10px" } : { padding: "10px 0" }}>
                                                    <div css={labTestStyles.dateText}>{date}</div>
                                                    {isExpanded && <React.Fragment>
                                                        {
                                                            <div className={"labTest-rows all-container-1"}>
                                                                {
                                                                    _.map(labTestRow, (labTests, index) => {
                                                                        return (
                                                                            <div key={`labTest-child-${index}`} onClick={() => this.handleLabTestClick(labTests, isMobile)}>
                                                                                <LabTestRowSideBar labTestRow={labTests} />
                                                                            </div>
                                                                        )
                                                                    })
                                                                }
                                                                {(labTestRow.length <= 0 && reportsPdf.length <= 0) &&
                                                                    <div>No Data</div>
                                                                }
                                                            </div>
                                                        }

                                                        {reportsPdf.length > 0 &&
                                                            <div onClick={(e: React.MouseEvent<HTMLDivElement, MouseEvent>) => this.showReports(e, rootIndex, reportsPdf, date, labTest, isMobile)} css={labTestStyles.viewPdfLink}>View Reports ({reportsPdf.length})</div>
                                                        }
                                                    </React.Fragment>}
                                                </div>
                                                <div css={labTestStyles.divider}></div>
                                            </div>
                                        }
                                    })
                                }
                                {
                                    newFormat && Object.keys(newFormat).map((date: string, index: number) => {
                                        const isExpanded: boolean = newFormatDateSelected === date;
                                        return (<div className={"labTest-container"} key={`labTest-new-root-${index}`} onClick={() => this.expandDateNewFormat(date)}>
                                            <div css={isExpanded ? { ...labTestStyles.expandedLabTest as any, padding: "10px" } : { padding: "10px 0" }}>
                                                <div css={labTestStyles.dateText}>{date}</div>
                                                {isExpanded && <React.Fragment>
                                                    {
                                                        <div className={"labTest-rows all-container-1"}>
                                                            <div>No Data</div>
                                                        </div>
                                                    }

                                                </React.Fragment>}
                                            </div>
                                            <div css={labTestStyles.divider}></div>
                                        </div>)
                                    })

                                }
                            </div>
                        </div>
                    }
                    {
                        this.state.openModal && <ModalComponent modalSize={"x-small"}>
                            <p className={"password-header"}>This Report is password protected. <br />Click below to copy password</p>
                            <div className={"copy-password-container"}>
                                <a onClick={this.handleCopyText}>Copy Password</a>
                                {<span className={copiedClass}><img src="/images/success.svg" />Copied</span>}
                            </div>
                            <div className={"cta-container"}>
                                <div className={"button cancel-button"} onClick={this.resetState}>Cancel</div>
                                <div className={"button ok-button"} onClick={this.openPasswordProtectedReport}>Open Report</div>
                            </div>
                        </ModalComponent>
                    }
                </div>}
                {!isMobile && <div css={labTestStyles.rightSection}>
                    {workingDate && <div css={Object.assign({}, labTestStyles.dateText, labTestStyles.rightHeader)}>{workingDate}</div>}

                    {(testsToShow && testsToShow.length > 0) &&
                        <div>
                            {!isMobile &&
                                <div className={"labTest-rows all-container-2"} css={labTestStyles.rightSideScroll}>
                                    {
                                        _.map(testsToShow, (labTests, index) => {
                                            return (
                                                <div key={`labTest-child-${index}`}>
                                                    <LabTestRow labTestRow={labTests} />
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                            }
                        </div>
                    }
                    {rightSideUi &&
                        rightSideUi
                    }
                    {labTestReportsCont}
                </div>}
                {isMobile && this.state.showDetails && <div style={{ width: "100%" }}>
                    <div style={{ display: "flex", alignItems: "center", padding: "10px 10px 10px 20px", borderBottom: "1px solid rgb(182, 198, 215)" }}>
                        <span style={{ fontSize: "22px", marginRight: "10px" }} onClick={this.handleBackClick}>{"<"}</span>
                        <span style={{ fontSize: "15px" }}>{this.state.detailToShow ? _.get(this.state.detailToShow, "childCheckUpReportInfo.0.reportDetails.testName", "") : !_.isEmpty(reportsToShow) ? workingDate : ""}</span>
                    </div>
                    <div>
                        {this.state.detailToShow && <LabTestRow labTestRow={this.state.detailToShow} hideTitle={true} />}
                    </div>
                    {labTestReportsCont}
                </div>}
            </div>
        );
    }
}

export default AllLabTestsContainer;